import '@ungap/global-this';
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue'
import Vuex from 'vuex'
import "@/conf/common.conf.js"
import bizStore from "@/store/biz.store.js"
import bizDetailStore from "@/store/biz.detail.store.js"
import newsStore from "@/store/news.store.js"
import App from '@/views/biz/BizApp.vue'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
      bizStore,
      bizDetailStore,
      newsStore
    }
});

new Vue({
  render: h => h(App),
  store,
}).$mount('#app');
